module.exports = __webpack_public_path__ + "static/media/tessa-error.7d19d78d.svg";